<template>
  <section class="imageItem">
    <img
      v-if="url && !imageError && !loading"
      :src="url"
      class="imageItem_img"
      alt=""
      @error="handleImageError"
    />
    <no-image
      v-if="!url || imageError || loading"
      height="revert-layer"
      width="100px"
      class="imageItem_no-image"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'ImageItem',
  props: {
    id: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      imageError: false,
    };
  },
  computed: {
    ...mapState({
      eventThumbnailUrl: (state) => state.event.eventThumbnailUrl,
    }),
    url() {
      return this.eventThumbnailUrl[this.id];
    },
    loading() {
      return this.url === undefined;
    },
  },
  watch: {},
  methods: {
    handleImageError() {
      this.imageError = true;
    },
  },
};
</script>

<style lang="scss">
.imageItem {
  height: auto;
  width: 100px;
  flex-grow: 0;
  flex-shrink: 0;
  margin-right: 10px;
  &_img {
    height: auto;
    width: 100%;
  }
  &_no-image {
    height: 100%;
    width: 100%;
  }
}
</style>
